import React from "react";
import { sitePath } from "../../lib/siteRouting";
import SiteLayout from "../../components/site/SiteLayout";
import { Link } from "react-router-dom";
import { Truck, Wrench, Layers, Factory, ArrowRight } from "lucide-react";
import SEOHead from "../../components/site/SEOHead";

const EQUIPS = [
  { icon: Factory, title: "Usine de production béton", desc: "Centrale de production béton sur site permettant la fabrication locale de planelles, hourdis, blocs et briques aux dimensions standards." },
  { icon: Truck, title: "Flotte de transport", desc: "Camions et bennes pour livraison rapide sur tout le territoire de Dakar et environs." },
  { icon: Wrench, title: "Outillage et matériel de chantier", desc: "Équipements de bétonnage, échafaudages, coffrages métalliques, grues mobiles." },
  { icon: Layers, title: "Atelier de préfabrication", desc: "Éléments préfabriqués en béton (poteaux de chaînage, chaînage en U, pierre de bordure)." },
];

export default function Equipements() {
  return (
    <SiteLayout>
      <SEOHead title="Nos équipements" description="Centrale béton, flotte de transport, atelier de préfabrication, outillage de chantier — l'intégration verticale TPCO Sénégal pour vos projets de construction à Dakar." />
      <div className="bg-[#F1F3FB] border-b border-[#E2E5F1] py-6">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-xs text-[#4B5775]">
          <Link to={sitePath("")} className="hover:text-[#1E3A8A]">Accueil</Link> / <span className="text-[#0F1A3D] font-semibold">Nos équipements</span>
        </div>
      </div>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="text-[14px] text-[#2E64A5] font-bold mb-4 tracking-wider">// NOS ÉQUIPEMENTS</div>
        <h1 className="font-display text-4xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Une intégration verticale<br />au service de vos chantiers.
        </h1>
        <p className="text-[#4B5775] text-lg max-w-3xl leading-[1.85] mb-16">TPCO Sénégal dispose de ses propres équipements industriels pour maîtriser chaque maillon de la chaîne — de la production des matériaux à la livraison finale du chantier.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {EQUIPS.map((e, i) => {
            const Icon = e.icon;
            return (
              <div key={i} className="bg-white border border-[#E2E5F1] p-8 hover:border-[#1E3A8A] hover:shadow-lg transition group">
                <div className="w-14 h-14 bg-[#E8EBFA] text-[#2E64A5] flex items-center justify-center mb-5 group-hover:bg-[#2E64A5] group-hover:text-white transition">
                  <Icon className="w-7 h-7" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-2xl font-extrabold mb-3 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>{e.title}</h3>
                <p className="text-sm text-[#4B5775] leading-relaxed">{e.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="mt-16 bg-[#0F1A3D] text-white p-12 text-center">
          <h2 className="font-display text-3xl font-extrabold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Besoin d'une étude technique ?</h2>
          <p className="text-white/70 mb-6 max-w-xl mx-auto">Nous mettons nos équipements et notre expertise à votre disposition pour vos projets de construction et de réhabilitation.</p>
          <Link to={sitePath("/contact")} className="inline-flex items-center gap-2 h-12 px-8 bg-[#E91E63] hover:bg-[#D81B60] text-white text-[13px] font-bold uppercase tracking-wider">
            Demander un devis <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}
